"use strict";

function toDate(value) {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value.toDate === "function") {
    return value.toDate();
  }

  if (typeof value.seconds === "number") {
    return new Date(value.seconds * 1000);
  }

  return null;
}

function formatDate(value, fallback) {
  const resolved = toDate(value);
  if (!resolved) {
    return fallback || "-";
  }

  return resolved.toLocaleDateString();
}

function formatDateTime(value, fallback) {
  const resolved = toDate(value);
  if (!resolved) {
    return fallback || "-";
  }

  return resolved.toLocaleString();
}

function formatCurrency(value) {
  const amount = typeof value === "number" && Number.isFinite(value) ? value : 0;
  return "$" + amount.toFixed(2);
}

function normalizeSearchText(value) {
  return String(value || "").trim().toLowerCase();
}

function buildSearchText(values) {
  return values
    .filter((value) => value !== null && value !== undefined && value !== "")
    .map((value) => String(value))
    .join(" ")
    .toLowerCase();
}

function getVerificationStatus(profile) {
  if (profile && profile.verificationStatus) {
    return profile.verificationStatus;
  }

  return profile && profile.verified ? "approved" : "pending";
}

const DINING_HALL_COORDS = {
  "64 Degrees": { latitude: 32.87485400210069, longitude: -117.242012645816 },
  "Cafe Ventanas": {
    latitude: 32.8861933456321,
    longitude: -117.2425847323241,
  },
  "Canyon Vista": {
    latitude: 32.884129820091374,
    longitude: -117.2332172169795,
  },
  "Club Med": { latitude: 32.87552038646682, longitude: -117.23496527465217 },
  OceanView: { latitude: 32.88322981160187, longitude: -117.24271315930723 },
  Pines: { latitude: 32.87892573833006, longitude: -117.24251640348834 },
  "Sixth College": {
    latitude: 32.88098036730501,
    longitude: -117.24213078607647,
  },
};

const DORM_COORDS = {
  "Argo Hall": { latitude: 32.8676, longitude: -117.2423 },
  "Blake Hall": { latitude: 32.8682, longitude: -117.2418 },
  "Fleet Hall": { latitude: 32.8679, longitude: -117.2428 },
  "Galathea Hall": { latitude: 32.8685, longitude: -117.2421 },
  "Discovery Hall": { latitude: 32.868, longitude: -117.2415 },
  "Atlantis Hall": { latitude: 32.8674, longitude: -117.2419 },
  "Beagle Hall": { latitude: 32.8683, longitude: -117.2425 },
  "Challenger Hall": { latitude: 32.8677, longitude: -117.2427 },
  "Meteor Hall": { latitude: 32.8681, longitude: -117.2422 },
  "Charles David Keeling Apartments": {
    latitude: 32.8668,
    longitude: -117.2412,
  },
  "Tioga Hall": { latitude: 32.8756, longitude: -117.2401 },
  "Tenaya Hall": { latitude: 32.8761, longitude: -117.2398 },
  "Tamarack Apartments": { latitude: 32.8758, longitude: -117.2405 },
  "Tuolumne Apartments": { latitude: 32.8763, longitude: -117.2395 },
  "Half Dome Apartments": { latitude: 32.8759, longitude: -117.2403 },
  Coalition: { latitude: 32.8821, longitude: -117.23974 },
  Umoja: { latitude: 32.8842, longitude: -117.2431 },
  Alianza: { latitude: 32.8845, longitude: -117.2425 },
  "Harlan Hall": { latitude: 32.8798, longitude: -117.2378 },
  "Bates Hall": { latitude: 32.8802, longitude: -117.2382 },
  "Frankfurter Hall": { latitude: 32.8805, longitude: -117.2375 },
  "Stewart Hall": { latitude: 32.8795, longitude: -117.238 },
  "Douglas Hall": { latitude: 32.88, longitude: -117.2372 },
  "Brown Hall": { latitude: 32.8792, longitude: -117.2376 },
  "Goldberg Hall": { latitude: 32.8803, longitude: -117.2379 },
  "Brennan Hall": { latitude: 32.8796, longitude: -117.2374 },
  "Black Hall": { latitude: 32.8799, longitude: -117.2377 },
  "Atkinson Hall": { latitude: 32.8801, longitude: -117.2373 },
  "Africa Hall": { latitude: 32.8815, longitude: -117.2435 },
  "Asia Hall": { latitude: 32.8818, longitude: -117.2438 },
  "Europe Hall": { latitude: 32.8812, longitude: -117.2432 },
  "Latin America Hall": { latitude: 32.8816, longitude: -117.2436 },
  "North America Hall": { latitude: 32.8813, longitude: -117.2433 },
  "Earth Hall North": { latitude: 32.8819, longitude: -117.2439 },
  "Earth Hall South": { latitude: 32.8817, longitude: -117.2437 },
  Oceania: { latitude: 32.8814, longitude: -117.2434 },
  "Middle East": { latitude: 32.882, longitude: -117.244 },
  "Oceania / Middle East": { latitude: 32.8814, longitude: -117.2434 },
  Geneva: { latitude: 32.8811, longitude: -117.2431 },
  Kathmandu: { latitude: 32.881, longitude: -117.243 },
  Cuzco: { latitude: 32.8809, longitude: -117.2429 },
  Asante: { latitude: 32.8808, longitude: -117.2428 },
  "Mesa Verde": { latitude: 32.8807, longitude: -117.2427 },
  "International House Apartments": {
    latitude: 32.8806,
    longitude: -117.2426,
  },
  "International House": { latitude: 32.8806, longitude: -117.2426 },
  Catalyst: { latitude: 32.8822, longitude: -117.2382 },
  Kaleidoscope: { latitude: 32.8831, longitude: -117.2391 },
  Mosaic: { latitude: 32.8828, longitude: -117.2388 },
  Tapestry: { latitude: 32.8834, longitude: -117.2394 },
  "Mosaic Hall": { latitude: 32.8828, longitude: -117.2388 },
  "Kaleidoscope Hall": { latitude: 32.8831, longitude: -117.2391 },
  "Catalyst Hall": { latitude: 32.8822, longitude: -117.2382 },
  "Tapestry Hall": { latitude: 32.8834, longitude: -117.2394 },
  "Meridian Hall": { latitude: 32.882, longitude: -117.238 },
  "Legacy Apartments": { latitude: 32.8818, longitude: -117.2378 },
  "North Torrey Pines Living & Learning Neighborhood": {
    latitude: 32.8815,
    longitude: -117.2375,
  },
  "Seventh East": { latitude: 32.8776, longitude: -117.2442 },
  "Seventh East Tower": { latitude: 32.8778, longitude: -117.2445 },
  "Seventh West": { latitude: 32.8773, longitude: -117.2445 },
  "Seventh West Tower": { latitude: 32.8775, longitude: -117.2448 },
  "East Tower (The Village)": { latitude: 32.8778, longitude: -117.2445 },
  "West Tower (The Village)": { latitude: 32.8775, longitude: -117.2448 },
  "EcoFlats (Buildings 2–5)": { latitude: 32.8772, longitude: -117.2451 },
  "West Buildings (Buildings 2–8)": { latitude: 32.8769, longitude: -117.2454 },
  "Village East Apartments": { latitude: 32.8776, longitude: -117.2442 },
  "Village West Apartments": { latitude: 32.8773, longitude: -117.2445 },
  "Podemos Hall": { latitude: 32.87368133117708, longitude: -117.24164137465225 },
  Podemos: { latitude: 32.87368133117708, longitude: -117.24164137465225 },
  "Pulse Hall": { latitude: 32.8783, longitude: -117.2463 },
  Pulse: { latitude: 32.8783, longitude: -117.2463 },
  "Sankofa Hall": { latitude: 32.8786, longitude: -117.2466 },
  Sankofa: { latitude: 32.8786, longitude: -117.2466 },
  "Survivance Hall": { latitude: 32.8789, longitude: -117.2469 },
  Survivance: { latitude: 32.8789, longitude: -117.2469 },
  "Azad Hall": { latitude: 32.8792, longitude: -117.2472 },
  Azad: { latitude: 32.8792, longitude: -117.2472 },
  "Theatre District Living and Learning Neighborhood": {
    latitude: 32.8777,
    longitude: -117.2457,
  },
  "Theatre District Living & Learning Neighborhood": {
    latitude: 32.8777,
    longitude: -117.2457,
  },
};

const UCSD_CAMPUS_CENTER = {
  latitude: 32.8801,
  longitude: -117.234,
  latitudeDelta: 0.03,
  longitudeDelta: 0.03,
};

const VEHICLE_SPEED_MPH = {
  bike: 8,
  "e-scooter": 8,
  foot: 3,
};

function findCoordinateMatch(value, lookup, allowPartial) {
  if (lookup[value]) {
    return lookup[value];
  }

  const normalizedValue = normalizeSearchText(value);
  if (!normalizedValue) {
    return null;
  }

  for (const [key, coords] of Object.entries(lookup)) {
    const normalizedKey = normalizeSearchText(key);
    if (normalizedKey === normalizedValue) {
      return coords;
    }
  }

  if (!allowPartial) {
    return null;
  }

  for (const [key, coords] of Object.entries(lookup)) {
    const normalizedKey = normalizeSearchText(key);
    if (
      normalizedValue.includes(normalizedKey) ||
      normalizedKey.includes(normalizedValue)
    ) {
      return coords;
    }
  }

  return null;
}

function getDiningHallCoords(name) {
  return findCoordinateMatch(name, DINING_HALL_COORDS, true);
}

function getDormCoords(name) {
  return findCoordinateMatch(name, DORM_COORDS, false);
}

function getLocationCoords(name) {
  return getDiningHallCoords(name) || getDormCoords(name);
}

function toRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

function roundToTwoDecimals(value) {
  return Math.round(value * 100) / 100;
}

function calculateStraightLineDistanceMiles(from, to) {
  const earthRadiusMiles = 3958.8;
  const deltaLatitude = toRadians(to.latitude - from.latitude);
  const deltaLongitude = toRadians(to.longitude - from.longitude);
  const fromLatitude = toRadians(from.latitude);
  const toLatitude = toRadians(to.latitude);

  const haversine =
    Math.sin(deltaLatitude / 2) * Math.sin(deltaLatitude / 2) +
    Math.cos(fromLatitude) *
      Math.cos(toLatitude) *
      Math.sin(deltaLongitude / 2) *
      Math.sin(deltaLongitude / 2);

  const arc = 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
  return earthRadiusMiles * arc;
}

function estimateEtaMinutes(distanceMiles, vehicleType) {
  const speedMph = VEHICLE_SPEED_MPH[vehicleType] || VEHICLE_SPEED_MPH.bike;
  if (!Number.isFinite(distanceMiles) || distanceMiles <= 0) {
    return 1;
  }

  return Math.max(1, Math.ceil((distanceMiles / speedMph) * 60));
}

function buildStraightLineEta(origin, destination, vehicleType) {
  const distanceMiles = calculateStraightLineDistanceMiles(origin, destination);
  return {
    distanceMeters: Math.round(distanceMiles * 1609.344),
    distanceMiles: roundToTwoDecimals(distanceMiles),
    estimatedMinutes: estimateEtaMinutes(distanceMiles, vehicleType),
    source: "straight_line",
    provider: "fallback",
  };
}

module.exports = {
  DINING_HALL_COORDS,
  DORM_COORDS,
  UCSD_CAMPUS_CENTER,
  buildStraightLineEta,
  buildSearchText,
  calculateStraightLineDistanceMiles,
  estimateEtaMinutes,
  formatCurrency,
  formatDate,
  formatDateTime,
  getDiningHallCoords,
  getDormCoords,
  getLocationCoords,
  getVerificationStatus,
  normalizeSearchText,
  toDate,
};
